import { render } from "./App.vue?vue&type=template&id=65e3fdb4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=65e3fdb4&lang=css"

import exportComponent from "E:\\Program Files\\xampp\\htdocs\\work\\Rifaja\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__